// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import PropTypes from 'prop-types';
import { ListActions, ListAction } from '@plesk/ui-library';
import { Locale } from 'jsw';
import { NotificationPropType } from './lib/PropTypes';

import './NotificationActions.less';

const NotificationActions = ({ notification: { id, isFavorite, code, notifications }, onMenuToggle = () => {}, onUpdateNotifications, onRemoveNotification }) => {
    const ids = notifications ? notifications.map(notification => notification.id) : [id];
    const locale = Locale.getSection('components.notification-center');
    return (
        <ListActions className="notification-actions" onMenuToggle={onMenuToggle}>
            <ListAction
                data-action={isFavorite ? 'NOTIFICATION_UNFAVORITE' : 'NOTIFICATION_FAVORITE'}
                data-type={code}
                icon={isFavorite ? 'star-filled' : 'star'}
                primary
                onClick={() => onUpdateNotifications(ids, {
                    isFavorite: !isFavorite,
                })}
                tooltipAsLabel
            >
                {locale.lmsg(isFavorite ? 'unfavoriteNotification' : 'favoriteNotification')}
            </ListAction>
            <ListAction
                data-action="NOTIFICATION_DELETE"
                data-type={code}
                icon="recycle"
                primary
                onClick={() => onRemoveNotification(ids)}
                tooltipAsLabel
            >
                {locale.lmsg(notifications ? 'deleteNotifications' : 'deleteNotification')}
            </ListAction>
        </ListActions>
    );
};

NotificationActions.propTypes = {
    notification: NotificationPropType.isRequired,
    onMenuToggle: PropTypes.func,
    onUpdateNotifications: PropTypes.func.isRequired,
    onRemoveNotification: PropTypes.func.isRequired,
};

export default NotificationActions;
